import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideSvgIconsConfig } from '@ngneat/svg-icon';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { ApiModule } from './api/backend-connector/api.module';
import { routes } from './app.routes';
import { DynamicImportLoader } from './i18n/dynamic-import-loader';
import { accountTreeIcon } from './svg/accountTree';
import { addIcon } from './svg/add';
import { addBubbleIcon } from './svg/addBubble';
import { analyzeWithAiIcon } from './svg/analyzeWithAI';
import { blurIcon } from './svg/blur';
import { cameraIcon } from './svg/camera';
import { cameraLensIcon } from './svg/cameraLens';
import { chevronLeftIcon } from './svg/chevron-left';
import { chevronRightIcon } from './svg/chevron-right';
import { compareIcon } from './svg/compare';
import { dashboardIcon } from './svg/dashboard';
import { driveFileMoveIcon } from './svg/drive_file_move';
import { enhanceIcon } from './svg/enhance';
import { extractMetadataIcon } from './svg/extractMetadata';
import { filesIcon } from './svg/files';
import { folderIcon } from './svg/folder';
import { folderSharedIcon } from './svg/folder_shared';
import { folderEyeIcon } from './svg/folderEye';
import { galleryThumbnailIcon } from './svg/galleryThumbnail';
import { generate360Icon } from './svg/generate360';
import { imageIcon } from './svg/image';
import { imageSearchIcon } from './svg/imageSearch';
import { landscapeIcon } from './svg/landscape';
import { lidarIcon } from './svg/lidar';
import { magicIcon } from './svg/magic';
import { minusIcon } from './svg/minus';
import { regionIcon } from './svg/region';
import { reportIcon } from './svg/report';
import { settingsIcon } from './svg/settings';
import { stickyNoteIcon } from './svg/stickyNote';
import { superviselyIcon } from './svg/supervisely';
import { timerIcon } from './svg/timer';
import { travelModeIcon } from './svg/travelMode';
import { unknownIcon } from './svg/unknown';
import { viewInArIcon } from './svg/viewInAr';
import { environment } from '../environments/environment';

export const svgIcons = [
  accountTreeIcon,
  addBubbleIcon,
  addIcon,
  analyzeWithAiIcon,
  blurIcon,
  cameraIcon,
  cameraLensIcon,
  chevronLeftIcon,
  chevronRightIcon,
  compareIcon,
  dashboardIcon,
  driveFileMoveIcon,
  enhanceIcon,
  extractMetadataIcon,
  filesIcon,
  folderEyeIcon,
  folderIcon,
  folderSharedIcon,
  galleryThumbnailIcon,
  generate360Icon,
  imageIcon,
  imageSearchIcon,
  landscapeIcon,
  lidarIcon,
  magicIcon,
  minusIcon,
  regionIcon,
  reportIcon,
  settingsIcon,
  stickyNoteIcon,
  superviselyIcon,
  timerIcon,
  travelModeIcon,
  viewInArIcon,
];

export type SvgName = (typeof svgIcons)[number]['name'];

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'it-IT' },
    provideRouter(routes, withComponentInputBinding()),
    provideSvgIconsConfig({
      icons: svgIcons,
      missingIconFallback: unknownIcon,
    }),
    importProvidersFrom(
      BrowserAnimationsModule,
      HttpClientModule,
      ApiModule.forRoot({
        rootUrl: environment.apiBasePath,
      }),
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLang,
        loader: {
          provide: TranslateLoader,
          useClass: DynamicImportLoader,
        },
      }),
    ),
  ],
};
